import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { useOrganizeSpacesInCollection } from '@tribeplatform/react-sdk/hooks';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { Modal } from '@tribeplatform/react-ui-kit/Modal';
import { SortableList } from '@tribeplatform/react-ui-kit/SortableList';
import { Text } from '@tribeplatform/react-ui-kit/Text';
import { toast } from '@tribeplatform/react-ui-kit/Toast';
import { T, useI18n } from '../i18n';
import { SpaceImage } from '../Space';
export const CollectionOrganizationModal = ({ collection, open, onClose, }) => {
    var _a;
    const intl = useI18n();
    const { mutateAsync: organizeSpaces, isLoading } = useOrganizeSpacesInCollection();
    const [sortedSpaces, setSortedSpaces] = useState(((_a = collection === null || collection === void 0 ? void 0 : collection.spaces) === null || _a === void 0 ? void 0 : _a.edges) || []);
    const hasSpaces = !!(sortedSpaces === null || sortedSpaces === void 0 ? void 0 : sortedSpaces.length);
    const onDragEnd = useCallback(result => {
        if (!result.destination) {
            return;
        }
        const newSortedSpaces = SortableList.reorder(sortedSpaces, result.source.index, result.destination.index);
        setSortedSpaces(newSortedSpaces);
    }, [sortedSpaces]);
    const onSave = useCallback(async () => {
        const spaceIds = sortedSpaces.map(({ node: { id } }) => id);
        const collectionId = collection === null || collection === void 0 ? void 0 : collection.id;
        try {
            await organizeSpaces({ collectionId, spaceIds });
        }
        catch (error) {
            toast({
                title: 'Something went wrong',
                description: error.message,
                status: 'error',
            });
            return;
        }
        onClose();
    }, [collection === null || collection === void 0 ? void 0 : collection.id, onClose, organizeSpaces, sortedSpaces]);
    if (!collection)
        return null;
    const spaces = sortedSpaces.map(it => it.node);
    return (_jsxs(Modal, { open: open, onClose: onClose, children: [_jsx(Modal.Header, { title: intl.$t({
                    id: 'Collection.CollectionOrganizationModal.HeaderTitle',
                    defaultMessage: 'Organize {SPACE} in the {COLLECTION}',
                }), description: intl.$t({
                    id: 'Collection.CollectionOrganizationModal.HeaderDescription',
                    defaultMessage: 'Customize order by dragging and dropping {SPACES}',
                }) }, void 0), _jsx(Modal.Content, { className: "overflow-y-auto my-4", style: { maxHeight: '75vh', paddingTop: 0, paddingBottom: 0 }, children: hasSpaces ? (_jsx("div", { className: "flex flex-col space-y-2", children: _jsx(SortableList, { id: "collection-space-items", onDragEnd: onDragEnd, items: spaces, renderItem: space => (_jsx(SortableList.Item, { id: space.id, children: _jsxs(SortableList.DefaultView, { children: [_jsx(SpaceImage, { space: space, size: "xs" }, void 0), _jsx("div", { className: "truncate", children: space.name }, void 0)] }, void 0) }, void 0)) }, void 0) }, void 0)) : (_jsx(Text, { children: _jsx(T, { id: "Collection.CollectionOrganizationModal.NoSpaceMessage", defaultMessage: "No {SPACES} in the {COLLECTION}" }, void 0) }, void 0)) }, void 0), _jsxs(Modal.Actions, { children: [_jsx(Button, { loading: isLoading, onClick: onSave, children: _jsx(T, { id: "Generics.Save", defaultMessage: "Save" }, void 0) }, void 0), _jsx(Button, { variant: "outline", onClick: onClose, children: _jsx(T, { id: "Generics.Cancel", defaultMessage: "Cancel" }, void 0) }, void 0)] }, void 0)] }, void 0));
};
//# sourceMappingURL=CollectionOrganizationModal.js.map